<template>
  <div class="projects" v-loading.fullscreen.lock="loading">
    <div class="projects-header">
      <!-- <div>
        区域:<span class="projects-header-area">{{ area }}</span>
      </div>-->
      <div>
        <el-button class="projects-header-search-btn" type="primary" @click="onCreateProject"
          >创建项目</el-button
        >
        <el-button type="primary" @click="onShowLogType">接入数据</el-button>
      </div>
      <div class="projects-header-search">
        <el-input v-model="keywords" placeholder="请输入关键字" @keyup.enter.native="onSearch">
          <i class="el-icon-search el-input__icon" slot="suffix" @click="onSearch"></i>
        </el-input>
      </div>
    </div>
    <div class="projects-content">
      <el-table class="projects-content-table" :data="projectList" stripe style="width: 100%">
        <el-table-column prop="name" label="项目名称">
          <template #default="scope">
            <ellipsis-card :title="scope.row.name" :keyword="scope.row.name"></ellipsis-card>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述">
          <template #default="scope">
            <ellipsis-card
              :title="scope.row.description"
              :keyword="scope.row.description"
            ></ellipsis-card>
          </template>
        </el-table-column>
        <el-table-column prop="regionId" label="区域" width="180"></el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" width="180"></el-table-column>
        <el-table-column label="操作">
          <template #default="scope">
            <el-button type="primary" @click="onClickDetail(scope.row.id)">详情</el-button>
            <el-button type="primary" @click="onEditProject(scope.row.id)">编辑</el-button>
            <el-button @click="onDeleteProject(scope.row)">删除</el-button>
          </template>
        </el-table-column>

        <div class="projects-empty" slot="empty">
          <p class="projects-empty-text">暂无项目</p>
          <img class="projects-empty-icon" src="../../../assets/img/empty.png" />
        </div>
      </el-table>

      <el-pagination
        class="projects-pagination"
        @current-change="handlePageChange"
        :current-page.sync="pagination.currentPage"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>

    <project-creator-and-editor
      ref="projectCreatorAndEditor"
      @submit="handleProjectCreated"
    ></project-creator-and-editor>

    <log-creator-and-editor
      ref="logCreatorAndEditor"
      @submit="handleLogCreated"
      @cancel="handleLogCancel"
    ></log-creator-and-editor>

    <log-type-selector ref="logTypeSelector" @clickDetail="handleDetailAccess"></log-type-selector>
  </div>
</template>

<script>
import { reqFetchProjects, reqDestroyProject } from '../../../api/project';
import ProjectCreatorAndEditor from '../common/ProjectCreatorAndEditor';
import LogCreatorAndEditor from '../common/LogCreatorAndEditor';
import LogTypeSelector from '../common/LogTypeSelector';
import EllipsisCard from '../common/EllipsisCard';

export default {
  name: 'Projects',

  components: {
    ProjectCreatorAndEditor,
    LogCreatorAndEditor,
    LogTypeSelector,
    EllipsisCard
  },

  data() {
    return {
      loading: false,
      area: '天津',
      keywords: '',
      projectList: [],
      projectId: null,
      pagination: {
        currentPage: 1,
        pageSize: 8,
        total: 0
      },
      ellipsisContentVisible: false,
      accessLogId: ''
    };
  },

  created() {
    this.getProjectList();
  },

  methods: {
    /**
     * 获取项目列表
     */
    async getProjectList() {
      try {
        this.loading = true;
        const params = {
          pageNo: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        };
        if (this.keywords) {
          params.keywords = this.keywords;
        }
        const { data } = await reqFetchProjects(params);
        this.projectList = data.projectDtoList;
        this.pagination.total = data.total;
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.pagination.currentPage = 1;
      this.getProjectList();
    },
    /**
     * 接入数据，选择日志类型
     */
    onShowLogType() {
      this.$refs.logTypeSelector.open();
    },
    /**
     * 跳转到接入数据页
     */
    handleDetailAccess() {
      // 有 projectId 时：创建项目之后继续创建日志库，再继续接入数据
      this.projectId
        ? this.$router.push({
            name: 'ProjectsDetailAccess',
            params: { projectId: this.projectId },
            query: { logId: this.accessLogId }
          })
        : this.$router.push({
            name: 'ProjectsAccess'
          });
    },
    /**
     * 创建项目
     */
    onCreateProject() {
      this.$refs.projectCreatorAndEditor.open({ drawerType: 'create' });
    },
    /**
     * 编辑项目
     */
    onEditProject(projectId) {
      this.$refs.projectCreatorAndEditor.open({ drawerType: 'edit', projectId: projectId });
    },
    /**
     * 跳转到项目详情页
     */
    onClickDetail(projectId) {
      this.$router.push({
        name: 'ProjectsDetail',
        params: { projectId: projectId }
      });
    },
    /**
     * 删除项目
     */
    async onDeleteProject(project) {
      try {
        await this.$msgbox({
          title: `警告`,
          message: `确定要删除项目【${project.name}】吗？`,
          type: 'warning',
          showCancelButton: true,
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            this.loading = true;
            const { data } = await reqDestroyProject({ projectId: project.id });
            if (data === 1) {
              this.$message.success('删除成功');
              this.getProjectList();
            } else if (data === 0) {
              this.$message.error('已绑定日志库，不可删除');
            } else {
              this.$message.error('删除失败');
            }
            done();
          }
        });
      } catch (e) {
        if (e === 'cancel') return;
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.getProjectList();
    },
    /**
     * 项目创建成功后的回调
     */
    handleProjectCreated(drawerType, name, projectId) {
      drawerType === 'edit'
        ? this.$message.success('保存成功')
        : this.$confirm(`项目: ${name} 创建成功! 是否立即创建日志库用于日志数据存储？`, '提示', {
            confirmButtonText: '创建日志库',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              this.projectId = projectId;
              this.$refs.logCreatorAndEditor.open({
                drawerType: 'create',
                projectId: projectId
              });
            })
            .catch(() => {});

      // 新增后列表条件重置
      this.pagination.currentPage = 1;
      this.keywords = '';
      this.getProjectList();
    },
    /**
     * 取消 log 创建之后，清空 projectId
     */
    handleLogCancel() {
      this.projectId = null;
    },
    /**
     * 日志库创建成功的回调
     */
    handleLogCreated(drawerType, name, log) {
      // 创建成功后，询问是否接入数据
      drawerType === 'edit'
        ? this.$message.success('保存成功')
        : this.$confirm(`日志库: ${name} 创建成功! 是否立即接入数据？`, '提示', {
            confirmButtonText: '接入数据',
            cancelButtonText: '取消',
            type: 'success'
          })
            .then(() => {
              this.$refs.logTypeSelector.open();
              this.accessLogId = log.id;
            })
            .catch(() => {
              this.accessLogId = null;
            });
    }
  }
};
</script>

<style lang="scss" scoped>
.projects {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  &-header {
    display: flex;
    justify-content: space-between;

    &-area {
      margin-left: 10px;
    }

    &-search {
      display: flex;
      justify-content: space-between;

      .el-icon-search {
        cursor: pointer;
      }
    }
  }

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;
    margin-top: 20px;

    &-table {
      flex: 1;
      overflow-y: auto;
    }
  }

  &-empty {
    flex: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-text {
      color: #999;
    }

    &-icon {
      margin: 50px 0;
    }
  }

  &-pagination {
    margin-top: 40px;
    text-align: center;
  }
}
</style>
